var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMetroCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-333"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2010",
    "data-name": "Rectangle 2010",
    width: 22,
    height: 22,
    fill: "#040227"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22402",
    "data-name": "Group 22402",
    transform: "translate(-0.064 -0.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22401",
    "data-name": "Group 22401",
    transform: "translate(0.064 0.064)",
    clipPath: "url(#clip-path-333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11605",
    "data-name": "Path 11605",
    d: "M20.169,2.2H18.336V1.467a1.467,1.467,0,0,0-2.934,0V2.2H12.468V1.467a1.467,1.467,0,1,0-2.934,0V2.2H6.6V1.467a1.467,1.467,0,1,0-2.934,0V2.2H1.834A1.834,1.834,0,0,0,0,4.034V18.7a1.834,1.834,0,0,0,1.834,1.834H12.1a.367.367,0,0,0,0-.733H1.834a1.1,1.1,0,0,1-1.1-1.1V7.334H21.269v6.234a.367.367,0,0,0,.733,0V4.034A1.834,1.834,0,0,0,20.169,2.2m-4.034-.733a.733.733,0,0,1,1.467,0v2.2a.733.733,0,0,1-1.467,0Zm-5.867,0a.733.733,0,0,1,1.467,0v2.2a.733.733,0,0,1-1.467,0Zm-5.867,0a.733.733,0,0,1,1.467,0v2.2a.733.733,0,0,1-1.467,0ZM21.269,6.6H.733V4.034a1.1,1.1,0,0,1,1.1-1.1H3.667v.733a1.467,1.467,0,0,0,2.934,0V2.934H9.535v.733a1.467,1.467,0,1,0,2.934,0V2.934H15.4v.733a1.467,1.467,0,0,0,2.934,0V2.934h1.834a1.1,1.1,0,0,1,1.1,1.1Z",
    transform: "translate(-0.019 -0.019)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11606",
    "data-name": "Path 11606",
    d: "M276.767,272a4.767,4.767,0,1,0,4.767,4.767A4.767,4.767,0,0,0,276.767,272m0,8.8a4.034,4.034,0,1,1,4.034-4.034,4.034,4.034,0,0,1-4.034,4.034",
    transform: "translate(-259.551 -259.551)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11607",
    "data-name": "Path 11607",
    d: "M322.932,340.321l-2.852,2.852-1.3-1.3a.367.367,0,0,0-.519.519l1.556,1.556a.367.367,0,0,0,.519,0l3.112-3.112a.367.367,0,0,0-.519-.519",
    transform: "translate(-303.596 -324.641)",
    fill: "#040227"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMetroCalendar);
export default __webpack_public_path__ + "static/media/icon-metro-calendar.91ab3c4c9d57e5cab82ed47c3664665f.svg";
export { ForwardRef as ReactComponent };